module.exports = {
  available: false,
  customSplashBanner: "",
  customSplashBannerColor: "",
  slug: "kauai2021",
  name: "Kauai",
  year: "2021",
  region: "Hawaii",
  country: "United States",
  location: "Kauai, Hawaii",
  subscriptionFee: 80,
  taxesAndFees: 600,
  soldOut: false,
  useHawaiiPricing: true,
  useHawaiiPhoneGate: false,
  soldOutPercent: 0,
  soldOutPercentHawaii: 0,
  soldOutReferralTrip: "",
  soldOutReferralText: "",
  banners: [""],
  thinBar1: "",
  thinBar2: "",
  saleEndsAt: "",
  onLocationPricingAvailable: false,
  onLocationPricingCutoff: "2019-09-28T06:00:00",
  onLocationMessage: "20th Year Anniversary Getaway",
  requireFirstNameForNewsletter: true,
  requireLastNameForNewsletter: true,
  requireFirstNameForNewsletterFooter: false,
  requireLastNameForNewsletterFooter: false,
  allowPayChangeDuringCheckout: true,
  dates: "May 30 - June 5, 2021",
  timeZone: "HST",
  startTime: "7:00 PM (HST)",
  checkInDay: "Sunday",
  checkInDate: "May 30, 2021",
  checkInTime: "4:00 PM (HST)",
  arrivePriorTo: "5:00 PM (HST)",
  checkOutDay: "Saturday",
  checkOutDate: "June 5, 2021",
  checkOutTime: "11:00 AM (HST)",
  disableMonthlyPaymentOption: false,
  maxSubMonths: 20,
  useMaxSubMonthsCutoff: "09-28-2019",
  availabilityCutoff: "05-28-2021",
  departureAirport: "Lihue",
  departureAirCode: "LIH",
  venue: "Grand Hyatt Kauai",
  venueSlug: "grand-hyatt-kauai",
  homeVideoId: "527592374",
  requestBrochureCategoryID: "9aa50add7a",
  finalDetailsFormHash: "zbqshq518z0am8",
  finalDetailsFormEnabled: false,
  postponementFormHash: "",
  postponementFormEnabled: false,
  postponementFormExtHash: "",
  postponementFormExtEnabled: false,
  mainPageModal: {
    enabled: true,
    title: "Kauai 2021 Travelers",
    message:
      "Important Trip Update (1/29/21): An email update has been sent to your email address on file.",
    button: {
      text: "KAUAI 2021",
      path: "/kauai2021",
    },
  },
  tripPageModal: {
    enabled: true,
    dismissible: false,
    title: "LOVESONG | Kauai 2021 Travelers",
    messageAlignment: "left",
    message: `
      <p>Important Trip Update (1/29/21): An email update has been sent to your email address on file with the subject line LOVESONG | Kauai 2021 Important Traveler Update.</p>
      <p>If you do not see the email update in your inbox, please be sure to check your promotions tab in Gmail or spam folder as sometimes they do get caught in there.</p>
      <p>If you are still unable to locate the email, please contact us at customercare@everlastingtours.com to let us know and include the names that the reservation is under.      </p>
      <p>Blessings,<br />
        Everlasting Tours</p>
    `,
  },
  mapUrl:
    "https://www.google.com/maps/place/Grand+Hyatt+Kauai+Resort+and+Spa/@21.8749881,-159.4398268,15.22z/data=!4m16!1m8!3m7!1s0x7c071a8dbc3559a3:0xa58bb3a68dd11846!2sGrand+Hyatt+Kauai+Resort+and+Spa!5m1!1s2018-05-13!8m2!3d21.8760842!4d-159.4393058!3m6!1s0x7c071a8dbc3559a3:0xa58bb3a68dd11846!5m1!1s2018-05-13!8m2!3d21.8760842!4d-159.4393058",
  perks: [
    "7 Days / 6 Nights Grand Hyatt Kauai Resort & Spa Accommodations",
    "$35 Daily Resort Fee (Self-Parking, High-Speed Internet, Access to 24 hour Anara Spa Fitness Center, Fitness Classes, Coffee Maker in Room with Hawaiian Coffee and Tea, Two Complimentary Refillable Water Bottles with Purified Water Stations, Guided Sunrise Walk, Torch Lighting Ceremony, Ukulele, Lei-making, and Hula Lessons, and more!)",
    "Porterage Fees (Baggage Handling)",
    "Everlasting Tours On-Location Staff",
    "Entertainment Wristbands ($500 value per person, included!)",
  ],
  subPerks: [
    "Speaking Sessions by Phenomenal Christian Speakers",
    "Performances by Chart Topping Christian Artists",
    "Morning Worship led by Musical Artists",
    "Meet & Greet Sessions with Speakers & Artists",
  ],
  lineup: [

  ],
  itinerary: [
    {
      name: "Sun",
      body:
        "\
        <p>\
          <strong>Day 1 | May 30</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>\
            Resort Check-in & LOVESONG Registration\
          </strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Grand Opening<br />\
          Opening Acoustic Performance</strong>\
        </p>\
      ",
    },
    {
      name: "Mon",
      body:
        "\
        <p>\
          <strong>Day 2 | May 31</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship Session<br />\
            Speaking Session 1 & 2\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – LOVESONG Gala*</strong>\
        </p>\
      ",
    },
    {
      name: "Tue",
      body:
        "\
        <p>\
          <strong>Day 3 | June 1</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>\
            Worship Session<br />\
           Speaking Session 3 & 4\
          </strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Optional Activity – Hawaiian Nights Social*</strong>\
        </p>\
      ",
    },
    {
      name: "Wed",
      body:
        "\
        <p>\
          <strong>Day 4 | June 2</strong>\
        </p>\
        <p>\
          Morning & Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Speaking Session 5</strong><br />\
          <strong>Accoustic Performance</strong>\
        </p>\
      ",
    },
    {
      name: "Thu",
      body:
        "\
        <p>\
          <strong>Day 5 | June 3</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Optional Activity – LOVESONG Interactive*</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Free Time</strong>\
        </p>\
      ",
    },
    {
      name: "Fri",
      body:
        "\
        <p>\
          <strong>Day 6 | June 4</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Worship Session</strong>\
        </p>\
        <p>\
          Afternoon:<br />\
          <strong>Free Time</strong>\
        </p>\
        <p>\
          Evening:<br />\
          <strong>Speaking Session 6</strong><br />\
          <strong>Final Night Performance</strong>\
        </p>\
      ",
    },
    {
      name: "Sat",
      body:
        "\
        <p>\
          <strong>Day 7 | June 5</strong>\
        </p>\
        <p>\
          Morning:<br />\
          <strong>Resort Checkout</strong>\
        </p>\
      ",
    },
  ],
  useCoupons: false,
  couponDisplay: 1,
  coupons: [],
  rooms: {
    standard: {
      key: "standard",
      name: "Standard Room",
      kind: "room",
      trip: "kauai2021",
      upsell: "pool",
      prices: {
        default: 5798,
        hawaii: 3998,
        onlocation: 4398,
      },
      extraNightPrices: {
        default: 450,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-standard.jpg",
      header: "/images/rooms/kauai2021-standard.jpg",
      description:
        "500 sqft. limited view room, Queen/Queen or one King (bedding type not guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer.",
    },
    pool: {
      key: "pool",
      name: "Pool View",
      kind: "room",
      trip: "kauai2021",
      upsell: "partial-ocean",
      prices: {
        default: 5998,
        hawaii: 4398,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-pool.jpg",
      header: "/images/rooms/kauai2021-pool.jpg",
      description:
        "500 sqft. pool view room, Queen/Queen or one King (bedding type not guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer.",
    },
    "standard-king": {
      key: "standard-king",
      name: "Standard Room - King Guaranteed",
      kind: "room",
      trip: "kauai2021",
      upsell: "partial-ocean-king",
      prices: {
        default: 5998,
        hawaii: 4298,
        onlocation: 4798,
      },
      extraNightPrices: {
        default: 500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-standard-king.jpg",
      header: "/images/rooms/kauai2021-standard-king.jpg",
      description:
        "500 sqft. limited view room, one King (bedding type guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer.",
    },
    "pool-king": {
      key: "pool-king",
      name: "Pool View - King Guaranteed",
      kind: "room",
      trip: "kauai2021",
      upsell: "partial-ocean-king",
      prices: {
        default: 5798,
        hawaii: 4598,
        onlocation: 4998,
      },
      extraNightPrices: {
        default: 550,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-pool-king.jpg",
      header: "/images/rooms/kauai2021-pool-king.jpg",
      description:
        "500 sqft. pool view room, one King (bedding type guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer.",
    },
    "partial-ocean": {
      key: "partial-ocean",
      name: "Partial Ocean View",
      kind: "room",
      trip: "kauai2021",
      upsell: "partial-ocean-king",
      prices: {
        default: 6198,
        hawaii: 4698,
        onlocation: 4998,
      },
      extraNightPrices: {
        default: 550,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-partial-ocean.jpg",
      header: "/images/rooms/kauai2021-partial-ocean.jpg",
      description:
        "500 sqft. ocean view room, Queen/Queen or one King (bedding type not guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer.",
    },

    "deluxe-ocean": {
      key: "deluxe-ocean",
      name: "Deluxe Ocean View",
      kind: "room",
      trip: "kauai2021",
      upsell: "deluxe-ocean-king",
      prices: {
        default: 6598,
        hawaii: 5298,
        onlocation: 5398,
      },
      extraNightPrices: {
        default: 600,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-deluxe-ocean.jpg",
      header: "/images/rooms/kauai2021-deluxe-ocean.jpg",
      description:
        "500 sqft. deluxe ocean view room, Queen/Queen or one King (bedding type not guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer.",
    },

    "partial-ocean-king": {
      key: "partial-ocean-king",
      name: "Partial Ocean View - King Guaranteed",
      kind: "room",
      trip: "kauai2021",
      upsell: "standard-suite",
      prices: {
        default: 6898,
        hawaii: 4998,
        onlocation: 5898,
      },
      extraNightPrices: {
        default: 600,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-partial-ocean-king.jpg",
      header: "/images/rooms/kauai2021-partial-ocean-king.jpg",
      description:
        "500 sqft. ocean view room, one King (bedding type guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer.",
    },

    "deluxe-ocean-king": {
      key: "deluxe-ocean-king",
      name: "Deluxe Ocean View - King Guaranteed",
      kind: "room",
      trip: "kauai2021",
      upsell: "standard-suite",
      prices: {
        default: 7498,
        hawaii: 5698,
        onlocation: 6498,
      },
      extraNightPrices: {
        default: 650,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-deluxe-ocean-king.jpg",
      header: "/images/rooms/kauai2021-deluxe-ocean-king.jpg",
      description:
        "500 sqft. deluxe ocean view room, one King (bedding type guaranteed), private lanai, seating area, marble bathroom, double sink vanity, a walk-in shower, and Hawaiian classic décor.   Room amenities include: 37” flat panel LCD TV, small chiller, robes, iron/ironing board, coffee maker, Coco Mango toiletries, in-room safe, hairdryer.",
    },
    "standard-suite": {
      key: "standard-suite",
      name: "Standard Suite",
      kind: "suite",
      trip: "kauai2021",
      upsell: "ocean-view-suite",
      prices: {
        default: 8598,
        hawaii: 7598,
        onlocation: 8598,
      },
      extraNightPrices: {
        default: 1000,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-standard-suite.jpg",
      header: "/images/rooms/kauai2021-standard-suite.jpg",
      description:
        "1055 - 1376 standard suite, one King, private lanai, separate sitting area, marble bathroom, double sink, a walk-in shower, and Hawaiian classic décor.   Room amenities include: Spa tub, work desk, dining table for 4, 42” flat panel LCD TV, small chiller, robes, coffee maker, in-room safe.",
    },
    "ocean-view-suite": {
      key: "ocean-view-suite",
      name: "Ocean View Suite",
      kind: "suite",
      trip: "kauai2021",
      upsell: "deluxe-ocean-view-suite",
      prices: {
        default: 11598,
        hawaii: 9598,
        onlocation: 10598,
      },
      extraNightPrices: {
        default: 1250,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-ocean-view-suite.jpg",
      header: "/images/rooms/kauai2021-ocean-view-suite.jpg",
      description:
        "1050 - 1084 ocean view suite, one King, private lanai, separate sitting area, marble bathroom, double sink, a walk-in shower, and Hawaiian classic décor.   Room amenities include: Spa tub, work desk, dining table for 4, 42” flat panel LCD TV, small chiller, robes, coffee maker, in-room safe.",
    },
    "deluxe-ocean-view-suite": {
      key: "deluxe-ocean-view-suite",
      name: "Deluxe Ocean View Suite",
      kind: "suite",
      trip: "kauai2021",
      upsell: false,
      prices: {
        default: 14598,
        hawaii: 9998,
        onlocation: 14598,
      },
      extraNightPrices: {
        default: 1500,
      },
      soldOut: true,
      popular: false,
      worthUpgrade: false,
      recommended: false,
      note: "",
      image: "/images/rooms/kauai2021-deluxe-ocean-view-suite.jpg",
      header: "/images/rooms/kauai2021-deluxe-ocean-view-suite.jpg",
      description:
        "1317 - 1877 deluxe suite, one King, private lanai, sitting area, marble bathroom, double sink, a walk-in shower, and Hawaiian classic décor.   Room amenities include: Whirlpool tub, work desk, dining table for 6, 42” flat panel LCD TV, small chiller, robes, coffee maker, in-room safe.",
    },
  },
};



// WEBPACK FOOTER //
// ./lib/trips/kauai2021.js